import sumBy from 'lodash/sumBy'
import _filter from 'lodash/filter'
import { PaymentStatusEnum, PurchaseOrderPaymentStatusEnum } from '@ztechapps/common.contract'
import { roundNumber } from '@ztechapps/common.utils'

export const getPaymentStatus = ({
  payments,
  net,
  originalPaymentStatus,
}: { payments?: any[]; net?: number; originalPaymentStatus?: PurchaseOrderPaymentStatusEnum } = {}) => {
  const allPaid = _filter(payments, (item) => {
    return (
      item?.status === PaymentStatusEnum.paid ||
      item?.status === PaymentStatusEnum.partiallyPaid ||
      item?.status === PaymentStatusEnum.partiallyRefunded ||
      item?.status === PaymentStatusEnum.adjusted
    )
  })

  let totalPaid = sumBy(allPaid, (item) => {
    return item?.gross
  })

  totalPaid = roundNumber(totalPaid, 2)

  if (allPaid?.length === 0 /* || totalPaid === */) return PurchaseOrderPaymentStatusEnum.Unpaid

  if (totalPaid === net) {
    return PurchaseOrderPaymentStatusEnum.Paid
  }

  if (totalPaid < net) {
    return PurchaseOrderPaymentStatusEnum.PartiallyPaid
  }

  if (totalPaid > net) return PurchaseOrderPaymentStatusEnum.OverPaid

  return originalPaymentStatus
}
